/**
 * O "G" do Google, para o botão "Continuar com Google".
 *
 * Não é ícone de interface: é a marca de um terceiro, e as regras de marca do Google
 * pedem o logo nas cores dele — por isso não passa pelo `Icon`, e a Lucide não tem
 * marcas. Os traços vêm do protótipo (`ui_kits/vecchia_app/AuthScreen.jsx`), não
 * foram desenhados aqui.
 */
export function MarcaDoGoogle({ tamanho = 17 }: { tamanho?: number }) {
    return (
        <svg width={tamanho} height={tamanho} viewBox="0 0 18 18" aria-hidden="true" focusable="false">
            <path fill="#4285F4" d="M17.6 9.2c0-.6-.1-1.2-.2-1.8H9v3.4h4.8a4.1 4.1 0 0 1-1.8 2.7v2.2h2.9c1.7-1.6 2.7-3.9 2.7-6.5z" />
            <path fill="#34A853" d="M9 18c2.4 0 4.5-.8 6-2.2l-2.9-2.2c-.8.5-1.8.9-3.1.9-2.4 0-4.4-1.6-5.1-3.8H.9v2.3A9 9 0 0 0 9 18z" />
            <path fill="#FBBC05" d="M3.9 10.7a5.4 5.4 0 0 1 0-3.4V5H.9a9 9 0 0 0 0 8l3-2.3z" />
            <path fill="#EA4335" d="M9 3.6c1.3 0 2.5.5 3.4 1.3l2.6-2.6A9 9 0 0 0 .9 5l3 2.3C4.6 5.2 6.6 3.6 9 3.6z" />
        </svg>
    );
}
